import type { WorkViewKey } from '../../billing/types/encounterWork';

/** Counts on the organization overview and morning worklist have no date limit. */
export const adminClaimWorkUrl = (organizationId: string, workView: WorkViewKey): string =>
  `/admin-v2/billing-dashboard/${encodeURIComponent(organizationId)}?view=${workView}&window=all&hidden=0`;
